import BanzaiClaimService from '@/services/banzai-claim.service'
import {AxiosInstance} from 'axios'
import _Vue from 'vue'

export default {
  install (
    Vue: typeof _Vue,
    { http }: { http: AxiosInstance }) {
    Vue.prototype.$banzaiClaim = new BanzaiClaimService(http)
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $banzaiClaim: BanzaiClaimService;
  }
}
